import create from 'zustand'
import {devtools} from 'zustand/middleware'

const useInputStore = create(devtools((set) => ({
  text:'',
  setText: (txt) => set((state) => ({text: txt})),
  editMode:false,
  setEditMode: (mode) => set((state) => ({editMode: mode})),
  position:null,
  setPosition:(pos) => set((state) => ({position: pos})),
  index: -1,
  setIndex: (i) => set((state) => ({index: i})),
  type:'',
  setType: (t) => set((state) => ({type: t})),
  data:'',
  setData: (dt) => set((state) => ({data: dt})),
  attributes:null,
  setAttributes: (obj) => set((state) => ({attributes: obj}))
})))

export default useInputStore
